<template>
    <div class="course-photo-container">
        <div class="header-container">
            <h2>{{ courseName }} </h2>
            <div v-if="userStore.isAuthenticated && userStore.authorities.includes('TEACHER-END-ALL')">
                <el-button type="primary" v-if="disabled" @click="disabled = false">Edit</el-button>
                <el-button type="success" v-else @click="disabled = true">Done</el-button>
            </div>
        </div>

        <el-divider class="my-divider" />

        <el-upload v-if="true || fileList.length > 0 || !disabled" v-model:file-list="fileList"
            :action="`${BACKEND_URL}/api/photo/content/${courseId}`" class="upload-container" list-type="picture-card"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleUploadSuccess"
            :on-error="handleUploadError" :with-credentials="true" multiple :disabled="disabled">
            <el-icon v-if="!disabled">
                <Plus />
            </el-icon>
            <span v-if="fileList.length <= 0">no photo</span>
        </el-upload>
        <PhotoDialog v-model="dialogVisible" :srcList="fileList.map(file => file.url)" :index="index" />
    </div>
</template>

<script>
import { Plus } from '@element-plus/icons-vue'
import PhotoDialog from '../../../share-source/src/components/PhotoDialog.vue'
import { BACKEND_URL } from '../../../share-source/src/config/config.js'
import axios from 'axios'
import { useUserStore } from '@/stores/Global.js'

export default {
    name: 'CoursePhoto',
    components: {
        // eslint-disable-next-line vue/no-unused-components
        Plus,
        PhotoDialog
    },
    setup() {
        const userStore = useUserStore()
        return {
            userStore
        }
    },
    data() {
        return {
            disabled: true,
            courseId: this.$route.params.id,
            courseName: this.$route.params.name,
            fileList: [],
            dialogVisible: false,
            BACKEND_URL: BACKEND_URL,
            index: 0
        }
    },
    created() {
        this.fetchCoursePhotos()
    },
    methods: {
        async fetchCoursePhotos() {
            try {
                const response = await axios.get(`${BACKEND_URL}/api/photo/course/${this.courseId}`)
                this.fileList = response.data.map(photo => ({
                    name: photo.name,
                    url: `${BACKEND_URL}/${photo.imageUrl}`,
                    id: photo.id
                }))
            } catch (error) {
                console.error('Error fetching course photos:', error)
                this.$message.error('Failed to load course photos')
            }
        },
        handlePictureCardPreview(uploadFile) {
            this.index = this.fileList.findIndex(photo => photo.id === uploadFile.id)
            this.dialogVisible = true
            // console.log("index: ", this.index)
        },
        async handleRemove(uploadFile) {
            try {
                if (uploadFile.id) {
                    await axios.delete(`${BACKEND_URL}/api/photo/content/${uploadFile.id}`)
                    this.$message.success('Photo deleted successfully')
                }
            } catch (error) {
                console.error('Error deleting photo:', error)
                this.$message.error('Failed to delete photo')
            }
        },
        handleUploadSuccess(response, uploadFile) {
            this.$message.success('Photo uploaded successfully')
            // Update the file list with the new photo data from response
            if (response && response.id) {
                uploadFile.id = response.id
            }
        },
        handleUploadError(error) {
            console.error('Upload error:', error)
            this.$message.error('Failed to upload photo')
        }
    }
}
</script>

<style scoped>
.course-photo-container {
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
}

:deep(.el-upload--picture-card) {
    object-fit: contain;
    line-height: 146px;
}

:deep(.el-upload-list--picture-card) {
    /* padding: 10px; */
    display: flex;
}

:deep(.el-upload-list--picture-card .el-upload-list__item) {
    width: 31%;
    object-fit: contain;
    border-radius: 10px;
    /* background-color: #865635; */
    /* border: 2px solid #00FF00; */
}

:deep(.el-upload--picture-card) {
    /* background-color: #865635; */
    width: 31%;
}

h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    /* margin-bottom: 0px; */
}

.my-divider {
    margin: 2px;
}

.header-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.upload-container {
    width: 100%;
}
</style>